import { MenusPlpComponent } from 'organisms/MenusPLP/AU';
import { getSeoPageWithObject } from '../productLandingPage';
import {
  LOCAL_STORAGE_KEYS,
  MENU_PAGE,
  CART_SELECT_STORE_MSG,
  POPSTATE,
  PICK_UP,
  ASAP,
} from 'common/constants/SharedConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import {
  getDispositionTypeOnAPIFormat,
  isEmptyObject,
  triggerCartModel,
  getAndCheck,
  localizeUserWithStoreInfo,
  getAndCheckIfOneTrue,
  getValueOrDefaultObject,
  getValueOrEmptyString,
  getTernaryValue,
  isCateringDisposition,
  goToMenuPage,
  checkByParams
} from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { BannerData } from 'organisms/BannerComponent';
import first from 'lodash/first';
import get from 'lodash/get';
import ScrollTop from 'molecules/ScrollTop';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import { CLOSED } from 'organisms/MenusPLP/MenuPLPConstants/MenuPLPConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { StructureData } from 'organisms/StructureDataComponent';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import AlertContainer from 'organisms/AlertComponent/Container/AU/AlertContainer';
import { menusNavRestrictionHandler, popStateListener } from 'organisms/MenusPLP/AU/MenusPlpUtilities/MenusPlpUtils';
import AlertFormInsideModel from 'molecules/Alert';
import AlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

export const checkLocationToShowModal = (setShowAlert, locationObject) =>
  locationObject?.state?.frompdp && setShowAlert(true);
export const onClickBtnHandler = ({
  event,
  setShowAlert,
  props,
  stoerName,
  getLocationParam,
  userOrderStateDispatch,
}) => {
  event.preventDefault();
  event.stopPropagation();
  setShowAlert(false);
  props?.history?.replace({ state: {} });
  getLocationParam && goToMenuPage();
  !getLocationParam && triggerCartModel(userOrderStateDispatch, stoerName);
};
export const showModalIftrue = (location, showAlert, itemUnavailableModel) =>
  location?.state?.frompdp && showAlert && itemUnavailableModel;

export const removeStatefromPDP = (props, setShowAlert) => {
  props?.history?.replace({ state: {} });
  setShowAlert(false);
};

export const getFinalPayloadData = ({ isForNow, dispositionNew, selectedEpochTime, payload }) => {
  return !isForNow && dispositionNew?.time !== ASAP
    ? { ...payload, futureDateTimeInEpochFormat: selectedEpochTime }
    : payload;
};

const ProductLandingPage = props => {
  const [seoPage, setSeoPage] = useState(MENU_PAGE);
  const [seoObj, setSeoObj] = useState();
  const { userOrderStateDispatch, userOrderState } = useContext(UserOrderContext);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { flatResponse: { categoryMapByUrl = {} } = {} } = useSelector(({ menuReducer }) => menuReducer) ?? {};
  const {
    data: { categories },
    searchResults: { categories: baseCategory = [] } = {},
  } = getValueOrDefaultObject(useSelector(({ menuReducer }) => menuReducer));
  let products = {};
  for (let cat of categories) {
    products[cat.url] = cat.products.map(p => ({
      '@type': 'MenuItem',
      name: getValueOrEmptyString(p?.name),
      description: getValueOrEmptyString(p?.url),
      url: getValueOrEmptyString(p?.longDescription[0]?.value),
    }));
  }
  const userParams = useSelector(state => state?.appStateReducer?.userStatus);
  const { tenantId } = getValueOrDefaultObject(tenantReducer);
  const { category_name } = useParams();
  const [showTopScrollBtn, setShowTopScrollBtn] = useState(true);
  const [storeClosedMsg, setStoreClosedMsg] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const { VIEW_MENU, STORE_TEXT, STORE_CLOSED_TEXT, CHANGE, CATERING_STORE_CLOSED_MSG } = TRANSLATE_MAPPING_KEY;
  const { START_ORDER_CLICK, NOT_WITHIN_OPERATING_HOURS, IS_DEEPLINK_URL, SCHEDULE_ORDER_DATA,STATUS_API_CALLED,STORE_NOT_ALIVE, DOORDASH_NOT_SERVICEABLE} = START_ORDER_CONSTANTS;
  const { ITME_NOT_AVAILABLE, BROWSE_MENU_TITLE, BROWSE_MENU } = MENU_PDP_PAGE_CONSTANTS;

  const dispositionNew = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW));
  const stoerName = dispositionNew?.store?.name[0]?.value;
  const getLocationParam = location?.state?.frompdp;
  const storesWithStatusData = useSelector(data => data.storesReducer?.storesWithStatus);
  const statusAPICalled = get(userOrderState, 'statusAPICalled', false);
  /* istanbul ignore next */
  const params = useMemo(() => {
    return {
      tenantReducer: isEmptyObject(tenantReducer)
        ? tenantReducer
        : JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.TENANT_REDUCER)),
      storeInfo: dispositionNew ? dispositionNew.store : {},
      selectedTile:
        userOrderState && isEmptyObject(userOrderState.selectedTile)
          ? userOrderState.selectedTile
          : JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.SELECTED_TILE)),
      dispositionType: dispositionNew?.type
        ? getDispositionTypeOnAPIFormat(dispositionNew.type)
        : getDispositionTypeOnAPIFormat(tenantReducer.authoredContent?.defaultdisposition),
    };
  }, [dispositionNew, userOrderState, tenantReducer]);

  useEffect(() =>{
    console.log("statusAPICalled",statusAPICalled)
   if(statusAPICalled){
    userOrderStateDispatch({ type: STATUS_API_CALLED, value: { statusAPICalled: false } });
    checkStoreStatus(storesWithStatusData)
   }
   },[statusAPICalled])
  useEffect(() => {
    const queryParams = location?.search?.split('?')[1];
    if (queryParams) {
      const urlSearchParams = new URLSearchParams(queryParams);
      const qparams = Object.fromEntries(urlSearchParams.entries());
      if (getAndCheckIfOneTrue(getAndCheck(qparams?.ordertype, qparams?.storeid), qparams?.action)) {
        userOrderStateDispatch({ type: IS_DEEPLINK_URL, value: { isDeepLinkURL: true } });
        getAndCheck(!userParams?.localized, qparams?.ordertype === PICK_UP) &&
          localizeUserWithStoreInfo(
            dispatch,
            qparams?.ordertype,
            qparams?.storeid,
            tenantId,
            userOrderStateDispatch,
            userParams,
            false,
            props?.history,
          );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Check menu navigation restriction
   */
  useEffect(() => {
    const paramsData = {
      pathname: location?.pathname,
      userParams,
      baseCategory,
      history: props?.history,
      menuNavRestricted: userOrderState.menuNavRestricted,
      userOrderStateDispatch,
    };
    menusNavRestrictionHandler(paramsData);
    checkLocationToShowModal(setShowAlert, location);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.pathname]);

  useEffect(() => {
    const { seoPageName, seoObject } = getSeoPageWithObject(tenantReducer, categoryMapByUrl, category_name) ?? {};
    setSeoPage(seoPageName);
    setSeoObj(seoObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId, category_name, JSON.stringify(categoryMapByUrl)]);

  useEffect(() => {
    return () => {
      window.removeEventListener(POPSTATE, event => popStateListener(event, userParams, userOrderStateDispatch), true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (getAndCheck(userParams.localized, dispositionNew?.store?.id)) {
      window.removeEventListener(POPSTATE, event => popStateListener(event, userParams, userOrderStateDispatch), true);
      window.addEventListener(POPSTATE, event => popStateListener(event, userParams, userOrderStateDispatch));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispositionNew?.store?.id, userParams]);

  const checkStoreStatus = storeDetails => {
    const stoerSummary = get(first(storeDetails), 'summary', {});
    const storeStatus = get(stoerSummary, 'status', {});
    const message = get(storeStatus, 'message', '');
    const startOrderBtnClicked = get(userOrderState, 'startOrderBtnClicked', false);
    if (get(storeStatus, 'currentStatus', '') === CLOSED) {
      setStoreClosedMsg(
        getTernaryValue(
          checkByParams(
            message !== NOT_WITHIN_OPERATING_HOURS,
            message !== STORE_NOT_ALIVE,
            getTernaryValue(message.includes(DOORDASH_NOT_SERVICEABLE), DOORDASH_NOT_SERVICEABLE, '') !==
            DOORDASH_NOT_SERVICEABLE,
          ),
          message,
          null,
        ),
      );
      setShowAlert(true);
    }
   startOrderBtnClicked && userOrderStateDispatch({ type: START_ORDER_CLICK, value: { startOrderBtnClicked: false } });
  };

  const cateringStoreClosedModel = getTernaryValue(
    showAlert,
    <AlertFormInsideModel
      handleClose={() => setShowAlert(false)}
      classNames='plp-warning-msg plp-page-model'
      CartAlertForm={
        <AlertForm
          title={`${translateWithI18Next(STORE_CLOSED_TEXT)}`}
          contentMsg={`${translateWithI18Next(CATERING_STORE_CLOSED_MSG)}`}
          imageSrc={IMAGE_PATH.LocationWithoutError}
          confirmButtonText={`${translateWithI18Next(CHANGE)} ${translateWithI18Next(STORE_TEXT)}`}
          confirmHandler={() => {
            userOrderStateDispatch({
              type: SCHEDULE_ORDER_DATA,
              value: {
                showScheduleOrderCatering: true,
                selectedStoreInfo: localStorage.getItem(LOCAL_STORAGE_KEYS.STORE_INFO),
                changeFlow: true,
              },
            });
            setShowAlert(false);
          }}
          cancelHandler={() => setShowAlert(false)}
          cancelButtonText={translateWithI18Next(VIEW_MENU)}
        />
      }
    />,
    null,
  );

  const storeCloseModel = (
    <AlertContainer
      handleClose={() => setShowAlert(false)}
      showAlert={showAlert}
      onClickBtnHandler={event =>
        onClickBtnHandler({ event, setShowAlert, props, stoerName, getLocationParam, userOrderStateDispatch })
      }
      stoerName={stoerName}
      storeClosedMsg={storeClosedMsg}
      contentMsg={CART_SELECT_STORE_MSG}
    />
  );

  const itemUnavailableModel = (
    <AlertContainer
      handleClose={() => {
        removeStatefromPDP(props, setShowAlert);
      }}
      showAlert={showAlert}
      imageSrc={IMAGE_PATH.CartErrorIcon}
      onClickBtnHandler={event =>
        onClickBtnHandler({ event, setShowAlert, props, stoerName, getLocationParam, userOrderStateDispatch })
      }
      stoerName={''}
      storeClosedMsg={ITME_NOT_AVAILABLE}
      contentMsg={BROWSE_MENU_TITLE}
      confirmButtonText={BROWSE_MENU}
    />
  );
  return (
    <React.Fragment>
      <BannerData />
      <StructureData page={seoPage} seoObj={seoObj} />
      <MenusPlpComponent
        setShowTopScrollBtn={setShowTopScrollBtn}
        contentData={params}
        selectedCat={props?.location?.selectedCat}
        history={props.history}
      />
      {userOrderState.showCartClearAlert && <ClearCartModule />}
      {showTopScrollBtn && <ScrollTop showThreshold={500} />}
      {getTernaryValue(isCateringDisposition(params?.dispositionType), cateringStoreClosedModel, storeCloseModel)}
      {showModalIftrue(location, showAlert, itemUnavailableModel)}
    </React.Fragment>
  );
};

export default ProductLandingPage;
